import { apiQueryClient } from 'common/query/queryClients';

import { fetchDashboards } from './api';
import { DASHBOARDS_QUERY_KEY } from './query';

export const preloadDashboards = async (): Promise<object> => {
  const codes = localStorage['selectedCountryCodes'];
  const countryCodes = codes ? JSON.parse(codes) : [];
  !apiQueryClient.getQueriesData({ queryKey: DASHBOARDS_QUERY_KEY })?.length &&
    countryCodes.length &&
    (await apiQueryClient.fetchInfiniteQuery({
      queryKey: DASHBOARDS_QUERY_KEY,
      initialPageParam: 1,
      queryFn: fetchDashboards,
    }));
  return Promise.resolve({});
};
